export default __webpack_public_path__ + "static/banner-real-stories-saving-spending-lending-seyma-90a0a87fbf04666ca68f207635dcc404.jpg";